export default "__VITE_ASSET__D_v4zSIr__"